import { DOMHelper } from "../../Helpers/DOMHelper.js";

export class Stepper {
    /**
     * stepper config
     * @param  FrontApp app      parent to access all other objects in the project
     * @param  String elementId  dom element ID to render the stepper
     * @param  String header   simple text or html to render in the top
     */
    constructor(app, elementId, header) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.elementId = elementId;
        this.steps = [];
        this.header = header;
        this.currentStep = -1;
    }

    /**
     * to add a page at the end of current steps
     * @param Object stepObject eg.
     * {
     * 		validation: callback(), //function
     * 		content: "string", //html
     * 		nextText: 'string'
     * }
     */
    addStep(stepObject) {
        this.steps.push(stepObject);
    }

    renderStepsContent() {
        let htmlResult = "",
            stepHtml = "",
            stepObject = {};
        let stepsCount = this.steps.length;
        for (var i = 0; i < stepsCount; i++) {
            stepObject = this.steps[i];
            stepHtml =
                `
			<div class='pm-drs-step ` +
                stepObject.class +
                `' data-index='` +
                i +
                `'>
				<p class="step-status-label"> Step ` +
                (i + 1) +
                ` of ` +
                stepsCount +
                `</p>
				<div class='step-content' >
				` +
                stepObject.content +
                `
				</div>

				<div class="steps-controls"> ` +
                this.getBackButton(stepObject, i) +
                `
					` +
                this.getNextButton(stepObject, i + 1) +
                `					
				</div>
			</div>
			`;
            htmlResult += stepHtml;
        }

        return htmlResult;
    }

    getBackButton(stepObject, index) {
        if (stepObject.back) {
            return (
                "<button type='button' class='step-btn btn-back' data-index_target=" +
                (index - 1) +
                ">" +
                stepObject.backText +
                "</button>"
            );
        }
        return "<span></span>";
    }

    getNextButton(stepObject, indexTarget) {
        let text = indexTarget == 1 ? "Submit & Continue" : "Submit";
        let submitBtn =
            `<button type="button" class="submit-step-btn color-white" data-index_target=` +
            indexTarget +
            ` data-arrow=` +
            stepObject.arrowNextValue +
            `>${text}</button>`;
        let nextBtn =
            `<button type="button" class="step-btn color-white btn-next" data-index_target=` +
            indexTarget +
            ` data-value=` +
            stepObject.lineValue +
            ` data-arrow=` +
            stepObject.arrowNextValue +
            `>` +
            stepObject.nextText +
            `</button>`;
        let finalText = indexTarget == 1 ? `<div>` + submitBtn + nextBtn + `</div>` : nextBtn;
        if (stepObject.nextText) {
            return finalText;
        }
        return (
            `<button type="button" class="submit-step-btn bg-blue color-white" data-index_target=` +
            indexTarget +
            `>${text}</button>`
        );
    }

    addHtml() {
        let html =
            `
		<div class="pm-drs-stepper">
			<div class="stepper-header"> ` +
            this.header +
            `</div>
			<div class="stepper-content">
				` +
            this.renderStepsContent() +
            `
			</div>
		</div>
		`;

        document.querySelector(this.getSelector("")).insertAdjacentHTML("beforeend", html);
    }

    addHtmlStepNumbers(id) {
        document.querySelector("#" + id).innerHTML = "";
        document.querySelector("#" + id).insertAdjacentHTML("beforeend", this.addStepNumbers());
    }

    init() {
        this.addHtml();
        this.addHandlers();
        this.showStep(0);
    }

    showStep(index) {
        if (this.currentStep > -1 && this.currentStep < index) {
            //not on init neither on going to prev steps
            let currentStepObject = this.steps[this.currentStep];
            if (typeof currentStepObject.validation == "function") {
                if (!currentStepObject.validation()) {
                    return;
                }
            }
        }
        let stepObject = this.steps[index];

        DOMHelper.removeClass(this.getSelector(".pm-drs-step"), "active");
        document.querySelector(this.getSelector(".pm-drs-step[data-index='" + index + "']")).classList.add("active");
        if (typeof stepObject.onShow === "function") {
            stepObject.onShow();
        }
        this.currentStep = index;
    }

    addHandlers() {
        let thisStepper = this;

        this.registerStepBtnHandler(this.getSelector(".step-btn"));
        this.registerStepBtnHandler(this.getSelectorFromDealPage(".step-btn"));

        document.addEventListener("click", function (event) {
            let steps = document.querySelectorAll(thisStepper.getSelectorFromDealPage("li.step"));
            let selected = event.target;
            let lineProgress = document.querySelector(thisStepper.getSelectorFromDealPage("#line-progress"));
            let arrowProgress = document.querySelector(thisStepper.getSelectorFromDealPage(".line.arrow-right"));
            if (event.target && event.target.classList.contains("step")) {
                console.log("contains step");
                // let line = document.querySelector(
                //     thisStepper.getSelector("#line")
                // );
                let index = selected.dataset.index_target;
                switch (index) {
                    case "0":
                        if (thisStepper.steps[thisStepper.currentStep].validation())
                            thisStepper.moveLineProgress(steps, selected, lineProgress);
                        thisStepper.moveArrorProgress(selected, arrowProgress);
                        arrowProgress.style.setProperty("--left", -100 * selected.dataset.arrow + "px");
                        arrowProgress.style.setProperty("--leftDesktop", -100 * selected.dataset.arrow + "px");
                        break;

                    case "1":
                    case "2":
                    case "3":
                    case "4":
                        if (index >= 1) {
                            console.log("entre case 1 2 3 4");
                            if (thisStepper.steps[thisStepper.currentStep].validation()) {
                                thisStepper.moveLineProgress(steps, selected, lineProgress);
                                thisStepper.moveArrorProgress(selected, arrowProgress);
                            }
                        }
                    default:
                        break;
                }
            } else if (event.target && event.target.classList.contains("step-btn")) {
                // click on button at top
                console.log("button at top");
                steps.forEach((step) => step.classList.remove("active"));
                if (event.target.classList.contains("btn-next")) {
                    let btnIndexTarget = selected.dataset.index_target;
                    let stepNumber = document.querySelector(
                        thisStepper.app.dealPage.getSelector("li.step-btn[data-index_target='" + btnIndexTarget + "']")
                    );
                    let index = stepNumber.dataset.index_target;
                    switch (index) {
                        case "0":
                            if (thisStepper.steps[thisStepper.currentStep].validation())
                                thisStepper.moveLineProgress(steps, selected, lineProgress);
                            arrowProgress.style.setProperty("--left", -100 * stepNumber.dataset.arrow + "px");
                            arrowProgress.style.setProperty("--leftDesktop", -100 * stepNumber.dataset.arrow + "px");
                            break;

                        case "1":
                        case "2":
                        case "3":
                        case "4":
                            if (thisStepper.steps[index - 1].validation()) {
                                steps.forEach((step) => step.classList.remove("active"));

                                stepNumber.classList.add("active");
                                lineProgress.style.width = 7 * stepNumber.dataset.value + "%";
                                thisStepper.moveArrorProgress(stepNumber, arrowProgress);
                            }
                        default:
                            break;
                    }
                } else {
                    // back button clicked at left bottom corner
                    let btnIndexTarget = selected.dataset.index_target;
                    console.log(btnIndexTarget);

                    let stepNumber = document.querySelector(
                        thisStepper.app.dealPage.getSelector("li.step-btn[data-index_target='" + btnIndexTarget + "']")
                    );

                    switch (btnIndexTarget) {
                        case "0":
                            if (thisStepper.steps[thisStepper.currentStep].validation()) {
                                thisStepper.moveLineProgress(steps, selected, lineProgress);
                                lineProgress.style.width = 7 * stepNumber.dataset.value + "%";
                                arrowProgress.style.setProperty("--left", -100 * stepNumber.dataset.arrow + "px");
                                arrowProgress.style.setProperty(
                                    "--leftDesktop",
                                    -100 * stepNumber.dataset.arrow + "px"
                                );
                            }
                            break;

                        default:
                            if (thisStepper.steps[btnIndexTarget - 1].validation()) {
                                stepNumber.classList.add("active");
                                lineProgress.style.width = 7 * stepNumber.dataset.value + "%";
                                arrowProgress.style.setProperty("--left", 16 * stepNumber.dataset.arrow + "px");
                                arrowProgress.style.setProperty("--leftDesktop", 16 * stepNumber.dataset.arrow + "px");
                            }
                            break;
                    }
                }
            } else if (event.target && event.target.classList.contains("text-inner")) {
                let index = selected.dataset.index_target;
                switch (index) {
                    case "0":
                        if (thisStepper.steps[thisStepper.currentStep].validation()) {
                            thisStepper.moveLineProgress(steps, selected, lineProgress);
                        }
                        break;

                    case "1":
                    case "2":
                    case "3":
                    case "4":
                        if (index >= 1) {
                            let valid = false;
                            for (let i = 0; i < steps.length - 1; i++) {
                                valid = thisStepper.steps[i].validation();
                                if (!valid) return false;
                            }
                            if (valid) thisStepper.moveLineProgress(steps, selected, lineProgress);
                        }
                    default:
                        break;
                }
            }
        });
    }

    registerStepBtnHandler(selector) {
        let thisStepper = this;

        DOMHelper.addHandler(selector, "click", function (event) {
            event.preventDefault();
            // console.log(this);
            if (
                event.target &&
                (event.target.classList.contains("step") ||
                    event.target.classList.contains("text-inner") ||
                    event.target.classList.contains("btn-next") ||
                    event.target.classList.contains("btn-back"))
            ) {
                let steps = document.querySelectorAll(thisStepper.getSelectorFromDealPage("li.step"));
                let valid = false;
                for (let i = 0; i < steps.length - 1; i++) {
                    valid = thisStepper.steps[i].validation();
                    if (!valid) return false;
                }
                thisStepper.showStep(this.dataset["index_target"]);
                let modal = document.querySelector(".start-deal-container");
                modal.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                    inline: "nearest",
                });
            }
        });
    }

    moveLineProgress(steps, selected, lineProgress) {
        console.log(selected);
        steps.forEach((step) => step.classList.remove("active"));

        selected.classList.add("active");
        // lineProgress.style.width = "calc(" + (7 * selected.dataset.value + "%") + " - 8px )";

        var targetPart = selected.dataset.index_target;
        var totalParts = this.steps.length - 1;
        var widthPercent = (targetPart / totalParts) * 100;
        var value = "calc(" + widthPercent + "% - 0px)"; //was 18 for the arrow
        lineProgress.style.width = value;
    }

    moveArrorProgress(selected, arrowProgress) {
        // let x = selected.offsetLeft;
        // let computed = window.getComputedStyle(selected, "::before");
        // let margin = computed.getPropertyValue("margin-right");
        // let intMargin = margin.replace(/[^\d.-]/g, "");
        // let value = parseFloat(x) + parseFloat(intMargin);
        // value = value -= 8;
        // arrowProgress.style.setProperty("--left", value + "px");
        // arrowProgress.style.setProperty("--leftDesktop", value + "px");

        var targetPart = selected.dataset.index_target * 2 + 1;
        var totalParts = this.steps.length * 2;
        var widthPercent = (targetPart / totalParts) * 100;
        var value = "calc(" + (widthPercent + "%") + " - 28px )";
        arrowProgress.style.setProperty("--left", value);
        arrowProgress.style.setProperty("--leftDesktop", value);
    }

    addStepNumbers() {
        let stepNumbers =
            "<div class='step-numbers'>" +
            "<div class='progress-wrapper'>" +
            "<div id='progress-bar-container'>" +
            "<ul>";
        let stepsCount = this.steps.length;
        for (let i = 0; i < stepsCount; i++) {
            stepNumbers +=
                "<li class='step step-btn " +
                this.steps[i].class +
                "' style='width: " +
                100 / stepsCount +
                "%' data-value=" +
                this.steps[i].lineValue +
                " data-index_target=" +
                i +
                " data-arrow=" +
                this.steps[i].arrowValue +
                ">" +
                "<div class='text-inner' data-index_target=" +
                i +
                " data-value=" +
                this.steps[i].lineValue +
                ">" +
                this.steps[i].title +
                "</div>" +
                "</li>";
        }

        var totalParts = this.steps.length * 2;
        var partsToUse = totalParts - 2;
        var left = (1 / totalParts) * 100 + "%";
        var width = (partsToUse / totalParts) * 100 + "%";
        stepNumbers +=
            "</ul>" +
            "<div id='line' style='width: " +
            width +
            "; left:" +
            left +
            " '>" +
            "<div id='line-progress'></div></div><span class='line arrow-right'></span>" +
            "</div></div></div>";

        return stepNumbers;
    }

    getSelector(selector) {
        return this.app.getSelector("#" + this.elementId + " " + selector);
    }

    getSelectorFromDealPage(selector) {
        return this.app.dealPage.getSelector(selector);
    }
}
